"use strict";

var _slicedToArray = require("/media/konapun/Data/Programming/projects/konapun.github.io/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("source-map-support/register");

var _parser = _interopRequireWildcard(require("@orbital-frame/parser"));

var _command = require("../command");

var _error = require("../error");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var compiler = function compiler() {
  return function (_ref) {
    var commandService = _ref.commandService,
        environmentService = _ref.environmentService;
    return {
      /**
       * Create a function from a source string
       *
       * @param {String} string source to parse into executable pipeline
       * @returns {Function} function that when executed evaluates the source string
       */
      compile: function compile(string) {
        var ast = this._parse(string);

        var builder = this._getBuilder(ast);

        return builder.build();
      },
      compileWithMetadata: function compileWithMetadata(string) {
        var ast = this._parse(string);

        var builder = this._getBuilder(ast);

        var metadata = (0, _command.metadataWalker)(builder.getMetadata());
        var command = builder.build();
        return {
          metadata: metadata,
          command: command
        };
      },
      _parse: function _parse(string) {
        try {
          return _parser.default.parse(string);
        } catch (err) {
          throw new _error.ParseError(err);
        }
      },
      _getBuilder: function _getBuilder(ast) {
        var _this = this;

        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var commandBuilder = (0, _command.builder)(commandService.registry, environmentService);
        var pipelines = [];
        var pipeline, command, option, currentBuilder;

        _parser.walker.walk(ast, function (node) {
          switch (node.type) {
            case _parser.type.PIPELINE:
              {
                pipeline = commandBuilder.addPipeline();
                pipelines.push(pipeline);
                currentBuilder = pipeline;
                break;
              }

            case _parser.type.ASSIGNMENT:
              {
                var _node$body = _slicedToArray(node.body, 2),
                    key = _node$body[0],
                    scope = _node$body[1];

                var assignment = commandBuilder.addVariable(key, scope);
                currentBuilder = assignment;
                break;
              }

            case _parser.type.INTERPOLATION:
              {
                var _node$body2 = _slicedToArray(node.body, 1),
                    source = _node$body2[0];

                var cmd = _this._getBuilder(source, options).build(_objectSpread({}, options, {
                  format: false
                })); // if interpolation is within a scope it should have access to scoped variables //FIXME: passing options both places is kind of ugly


                currentBuilder.addArgument(cmd);
                return _parser.walker.treeControl.SUBTREE_STOP; // subtree processing is handled by the recursive call of _getBuilder
              }

            case _parser.type.FUNCTION:
              {
                var _node$body3 = _slicedToArray(node.body, 2),
                    name = _node$body3[0],
                    body = _node$body3[1];

                var fnOpts = {
                  scope: name
                };

                var _cmd = _this._getBuilder(body, fnOpts).build(fnOpts);

                var execute = function execute() {
                  return _cmd();
                }; // swallow args and opts since functions get these through env variables


                commandService.load(function () {
                  return {
                    name: name,
                    execute: execute
                  };
                });
                return _parser.walker.treeControl.SUBTREE_STOP; // subtree processing is handled by the recursive call of _getBuilder
              }

            case _parser.type.COMMAND:
              {
                var _node$body4 = _slicedToArray(node.body, 1),
                    _name = _node$body4[0];

                command = pipeline.addCommand(_name);
                currentBuilder = command;
                break;
              }

            case _parser.type.OPTION:
              {
                var _node$body5 = _slicedToArray(node.body, 1),
                    _key = _node$body5[0];

                option = command.addOption(_key);
                currentBuilder = option;
                break;
              }

            case _parser.type.ARGUMENT:
              {
                var _node$body6 = _slicedToArray(node.body, 1),
                    value = _node$body6[0];

                if (currentBuilder) {
                  currentBuilder.addArgument(value);
                }

                currentBuilder = command;
                break;
              }

            case _parser.type.VARIABLE:
              {
                var _node$body7 = _slicedToArray(node.body, 1),
                    _key2 = _node$body7[0];

                currentBuilder.addVariable(_key2);
                break;
              }
          }
        });

        return commandBuilder;
      }
    };
  };
};

var _default = compiler;
exports.default = _default;